import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter, connectRouter, routerMiddleware } from "connected-react-router";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { reducer as oidcReducer } from "redux-oidc";
import { createBrowserHistory } from "history";
import createOidcMiddleware from 'redux-oidc';

import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import mapReducers from "./store/Map";
import userManager from './services/UserManager';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

const loggerMiddleware = store => next => action => {
    console.log("Action type:", action.type);
    console.log("Action payload:", action.payload);
    console.log("State before:", store.getState());
    next(action);
    console.log("State after:", store.getState());
};

//const oidcMiddleware = createOidcMiddleware(userManager);

const devMiddleware = [
    loggerMiddleware,
    //oidcMiddleware,
    ...getDefaultMiddleware({
        serializableCheck: false //consider ignoredPaths. See https://github.com/reduxjs/redux-toolkit/releases/tag/v1.2.3
    }),
    routerMiddleware(history)
];

const prodMiddleware = [
    //oidcMiddleware, 
    ...getDefaultMiddleware({
        serializableCheck: false //consider ignoredPaths. See https://github.com/reduxjs/redux-toolkit/releases/tag/v1.2.3
    }),
    routerMiddleware(history)
];

var middleware = prodMiddleware;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    middleware = devMiddleware;
}


const rootReducer = {
    map: mapReducers,
    //oidc: oidcReducer,
    router: connectRouter(history)
};

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore({
    reducer: rootReducer,
    middleware
});

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root"));

registerServiceWorker();
